import { routerReducer } from 'react-router-redux';
import adminReducer from './admin';
import userReducer from './user';
import modalReducer from './modal';
import checkoutReducer from './checkout';

export default {
  admin: adminReducer,
  router: routerReducer,
  user: userReducer,
  modal: modalReducer,
  checkout: checkoutReducer
};


// WEBPACK FOOTER //
// ./modules/rootReducer.js